import { render, staticRenderFns } from "./user-edit.vue?vue&type=template&id=e2df963c&scoped=true"
import script from "./user-edit.vue?vue&type=script&lang=js"
export * from "./user-edit.vue?vue&type=script&lang=js"
import style0 from "./user-edit.vue?vue&type=style&index=0&id=e2df963c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2df963c",
  null
  
)

export default component.exports